export default __webpack_public_path__ + "static/media/VO_Reel.044e82c6.mp3";